export type SessionRole = {
  roleId: string
  role: string
  code: string
  username: string
  email: string
  initials: string
  ts: number
}

export const DEFAULT_SESSION: SessionRole = {
  roleId: 'presiden',
  role: 'Presiden RI',
  code: 'VVIP-01',
  username: 'presiden.ri',
  email: 'presiden.ri@gov.id',
  initials: 'RI',
  ts: 0,
}

export const ROLE_OPTIONS: Omit<SessionRole, 'ts'>[] = [
  {
    roleId: 'presiden',
    role: 'Presiden RI',
    code: 'VVIP-01',
    username: 'presiden.ri',
    email: 'presiden.ri@gov.id',
    initials: 'RI',
  },
  {
    roleId: 'pimpinan',
    role: 'Pimpinan Pengamanan',
    code: 'SEC-LEAD',
    username: 'sec.lead',
    email: 'pimpinan.amankam@gov.id',
    initials: 'PP',
  },
  {
    roleId: 'command',
    role: 'Kepala Command Center',
    code: 'CC-01',
    username: 'kepala.cc',
    email: 'command.center@bssn.go.id',
    initials: 'CC',
  },
  {
    roleId: 'analis',
    role: 'Analis Intelijen',
    code: 'A-12',
    username: 'analis.a12',
    email: 'analis.intel@bin.go.id',
    initials: 'AI',
  },
  {
    roleId: 'komunikasi',
    role: 'Tim Komunikasi',
    code: 'KOM-04',
    username: 'tim.komunikasi',
    email: 'komunikasi@kominfo.go.id',
    initials: 'TK',
  },
  {
    roleId: 'kementerian',
    role: 'Kementerian / Lembaga',
    code: 'KL-22',
    username: 'liaison.kl',
    email: 'liaison.kl@gov.id',
    initials: 'KL',
  },
  {
    roleId: 'pemda',
    role: 'Pemerintah Daerah',
    code: 'PEMDA-14',
    username: 'pemda.liaison',
    email: 'pemda.liaison@daerah.go.id',
    initials: 'PD',
  },
  {
    roleId: 'auditor',
    role: 'Auditor',
    code: 'AUD-09',
    username: 'auditor.bpk',
    email: 'audit@bpk.go.id',
    initials: 'AU',
  },
]

export function getSession(): SessionRole {
  try {
    const raw = localStorage.getItem('gs_auth')
    if (!raw) return DEFAULT_SESSION
    const parsed = JSON.parse(raw)
    return { ...DEFAULT_SESSION, ...parsed }
  } catch {
    return DEFAULT_SESSION
  }
}

export function setSession(s: Partial<SessionRole>) {
  try {
    const next = { ...getSession(), ...s, ts: Date.now() }
    localStorage.setItem('gs_auth', JSON.stringify(next))
    window.dispatchEvent(new CustomEvent('gs_session_change', { detail: next }))
    return next
  } catch {
    return getSession()
  }
}

export function clearSession() {
  try {
    localStorage.removeItem('gs_auth')
    window.dispatchEvent(new CustomEvent('gs_session_change'))
  } catch {}
}

export function getRoleAvatarUrl(roleId: string) {
  return `https://i.pravatar.cc/150?u=${roleId}`
}
